import { Shell } from './components/Shell';
import { useStore } from './state/store';
import { InicioPage } from './features/inicio/InicioPage';
import { AgendaPage } from './features/agenda/AgendaPage';
import { ColorsPage } from './features/agenda/ColorsPage';
import { SpacePage } from './features/espacio/SpacePage';
import { DemoGate } from './components/DemoGate';

/**
 * Navegación por “áreas abiertas” (barra inferior). Sin router a propósito:
 * al integrar, mapear cada área a la ruta del router que use connectacleaner-front.
 */
export function App() {
  const s = useStore();
  const real = s.dataSource === 'real';
  return (
    <Shell>
      {s.active === 'inicio' && (real ? <DemoGate title="Inicio" /> : <InicioPage />)}
      {s.active === 'agenda' && <AgendaPage />}
      {s.active === 'espacio' && <SpacePage key={`${s.dataSource}:${s.caller?.name ?? 'nuevo'}`} />}
      {s.active === 'colores' && (real ? <DemoGate title="Colores" /> : <ColorsPage />)}
    </Shell>
  );
}
